/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.10
 */

export type ReportsFindSimilarReportsCategoryOfTest =
  (typeof ReportsFindSimilarReportsCategoryOfTest)[keyof typeof ReportsFindSimilarReportsCategoryOfTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindSimilarReportsCategoryOfTest = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
